import { useQuery } from "@tanstack/react-query";
import { oneOnboardingApi } from "libs/api";
import { useDynamicLocation } from "../commons/hooks/useDynamicLocation";
import { TanstackQueryKey } from "../commons/tanstackQueryKey";
import { useOnboardingPageContextAtomState } from "./onboardingPageContextAtom";
import { isOnboardingRouteValid, toOnboardingApiIdentity } from "./routes/onboardingRouteApi";
import { useOnboardingRouteId } from "./useOnboardingRouteId";

export const useOnboardingPageContextApi = () => {
    const route = useOnboardingRouteId();
    const apiIdentity = toOnboardingApiIdentity(route);
    const { pathname } = useDynamicLocation();
    const [pageContext, setPageContext] = useOnboardingPageContextAtomState();
    const { isFetching, isError, refetch } = useQuery({
        queryKey: [TanstackQueryKey.GetOnboardingPageContext, route.lang, route.id, pathname],
        queryFn: () =>
            oneOnboardingApi
                .getOnboardingPageContext(route.lang, pathname, apiIdentity.propertyId, apiIdentity.onboardingId)
                .then((res) => res.data),
        enabled: isOnboardingRouteValid(route),
        onSuccess: (data) => setPageContext(data),
    });

    return {
        data: pageContext,
        isLoading: isFetching,
        isError,
        refetch,
    };
};
